import { Component, OnInit } from '@angular/core';
import { LocalStorage } from "@ngx-pwa/local-storage";
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  toggleSidebar;
  ismobile = false;

  constructor(
    public ds: DataService,
    public localStorages: LocalStorage,
    public breakpointObserver: BreakpointObserver,
    private router: Router,
  ) { }

  ngOnInit() {
    // const isSmallScreen = this.breakpointObserver.isMatched('(max-width: 736px)');
    this.breakpointObserver
      .observe(['(max-width: 736px)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.ismobile = state.matches;
        } else {
          this.ismobile = state.matches;
        }
      });

  }

  togglesidebar() {
    let body = document.getElementsByClassName("page-wrapper")[0];
    body.classList.toggle("toggled-sidebar");
    this.toggleSidebar = !this.toggleSidebar;
    this.localStorages
      .setItem("toggleSidebar", this.toggleSidebar)
      .subscribe(() => { });
  }

  onLogOut() {
   
  }

}
